import { render, staticRenderFns } from "./_icon.vue?vue&type=template&id=c80b19f0"
import script from "./_icon.js?vue&type=script&lang=js&external"
export * from "./_icon.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports